import {
  buildIntercomIdentity,
  resolveActivePartner,
  useCurrentUser,
  useIsArticAdmin,
} from '@artic/api-client';
import { useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';

/**
 * Identifies the signed-in user to Intercom with their Name, Email and Partner.
 *
 * The payload is built by the shared `buildIntercomIdentity` in
 * `@artic/api-client` so every Artic SPA reports the same attributes — see that
 * module for the name-fallback and Artic-staff company rules.
 */
export function IntercomIdentity() {
  const { user, partners, activePartner } = useCurrentUser();
  const isArticAdmin = useIsArticAdmin();
  const { update } = useIntercom();

  useEffect(() => {
    // Built inside the effect: a payload object constructed during render would
    // be a fresh identity every time and re-fire this effect on every render.
    const partner = resolveActivePartner(partners, activePartner);
    update(buildIntercomIdentity({ user, partner, isArticAdmin }));
  }, [update, user, partners, activePartner, isArticAdmin]);

  return null;
}
